// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8nuqw","parentHeight":"styles_parentHeight__Z5awr","text":"styles_text__a5q04"};